import { useAppService, useSelectedOrgId } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import type { AppService } from "adl-gen/app-service";
import { assertNotUndefined } from "utils/hx/util/types";

export const useGetStockDataCountsQuery = () => {
  const service: AppService = useAppService();
  const organisationId = assertNotUndefined(useSelectedOrgId());

  return useQuery({
    queryKey: ["getStockDataCounts", organisationId],
    queryFn: () => service.getStockDataCounts({ organisationId }),
  });
};
